import { FC, useEffect } from "react";
import { Ticket } from "../../../types/slices/ticketType";
import { Grid, Typography } from "@mui/material";
import { useTheme } from '@mui/material';

interface DocumentInfoPros {
    ticket:Ticket
    idtype_document:number
}

export const DocumentInfo:FC<DocumentInfoPros> = ({ticket, idtype_document}) => {

    const theme = useTheme()

    const CustomerInfo = (idtype_document:number) => {
        let info:JSX.Element = <></>
        switch (idtype_document) {
            // Boleta
            case 1:
                info = <></>
                break;
        
            default:
                // <>
                // <Grid item container xs={12} md={6}>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             RUT / NIT / DNI
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.rut_customer}</Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             {'Señor(es)'}
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.name_customer.toUpperCase()}</Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%'
                //         }}
                //         >
                //             Giro
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.giro_customer.toUpperCase()}</Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%'
                //         }}
                //         >
                //             Dirección
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.address_customer.toUpperCase()}</Typography>
                //     </Grid>
                //     <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%'
                //         }}
                //         >
                //             Distrito
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.district_customer.toUpperCase()}</Typography>
                //     </Grid>
                //     <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%'
                //         }}
                //         >
                //             Provincia
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.province_customer.toUpperCase()}</Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%'
                //         }}
                //         >
                //             País
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px',lineHeight: '100%', }}>{ticket?.country_customer.toUpperCase()}</Typography>
                //     </Grid>
                // </Grid>
                // <Grid item container xs={12} md={6} sx={{
                //     [theme.breakpoints.up('md')]: { paddingLeft: '0 !important' },
                //     [theme.breakpoints.down('md')]: { paddingTop: '0 !important' }
                // }}>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             Puerto embarque
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}></Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             Puerto desembarque
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}></Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             Nombre buque
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}></Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             Nota de venta
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>DOLAR USA</Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             Forma de pago
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>pac prueba para gesa</Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{
                //             backgroundColor: '#F5F5F5',
                //             color: '#000000',
                //             fontWeight: 'bolder',
                //             height: '100%',
                //             marginRight: 'auto',
                //             padding: '5px',
                //             width: '100%',
                //         }}
                //         >
                //             Total peso neto
                //         </Typography>
                //     </Grid>
                //     <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '50px' }}>
                //         <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>KG</Typography>
                //     </Grid>
                // </Grid>
                // </>
                break;
        }
        return info
    }

    return(<>
        <Grid item xs={12} md={7} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography>{ticket?.company?.toUpperCase()}</Typography>
            <Typography>{ticket?.giro_company}</Typography>
            <Typography>{ticket?.address_company}</Typography>
            <Typography>Región Metropolitana - Chile</Typography>
            <Typography>Fonos: {ticket?.phone_company}</Typography>
            <Typography>www.softnet.cesione.cl - www.softnet.recepcione.cl</Typography>
        </Grid>
        <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Grid sx={{
                alignItems: 'center',
                border: '2px solid #000000',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '15px 0px'
            }}>
                <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '5px' }}>R.U.T.: {ticket?.rut_company}</Typography>
                <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '5px' }}>{'PEDIDO'}</Typography>
                <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '5px' }}>N° {ticket?.nro_ticket}</Typography>
            </Grid>
            <Typography sx={{ color: '#000000', fontWeight: 'bolder', margin: '10px auto' }}>S.I.I.- SANTIAGO ORIENTE</Typography>
            <Typography sx={{ marginLeft: 'auto' }}>Santiago, {ticket?.date_format}</Typography>
        </Grid>
        <Grid item container xs={12} md={12} sx={{ borderBottom: '4px solid #516E80', marginLeft: '16px' }}>
            <Typography sx={{ backgroundColor: '#516E80', color: '#fff', marginRight: 'auto', padding: '5px 10px', marginLeft: '-16px' }}>Datos del cliente</Typography>
        </Grid>
        <Grid item container xs={12} md={6}>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '30px' }}>
                <Typography sx={{
                    backgroundColor: '#F5F5F5',
                    color: '#000000',
                    fontWeight: 'bolder',
                    height: '100%',
                    marginRight: 'auto',
                    padding: '5px',
                    width: '100%',
                }}
                >
                    RUT / NIT / DNI
                </Typography>
            </Grid>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', borderTop: '2px solid #858585', height: '30px' }}>
                <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.rut_customer}</Typography>
            </Grid>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{
                    backgroundColor: '#F5F5F5',
                    color: '#000000',
                    fontWeight: 'bolder',
                    height: '100%',
                    marginRight: 'auto',
                    padding: '5px',
                    width: '100%',
                }}
                >
                    {'Señor(es)'}
                </Typography>
            </Grid>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.name_customer?.toUpperCase()}</Typography>
            </Grid>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{
                    backgroundColor: '#F5F5F5',
                    color: '#000000',
                    fontWeight: 'bolder',
                    height: '100%',
                    marginRight: 'auto',
                    padding: '5px',
                    width: '100%'
                }}
                >
                    Giro
                </Typography>
            </Grid>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.giro_customer?.toUpperCase()}</Typography>
            </Grid>
        </Grid>
        <Grid item container xs={12} md={6} sx={{
            [theme.breakpoints.up('md')]: { paddingLeft: '0 !important' },
            [theme.breakpoints.down('md')]: { paddingTop: '0 !important' }
        }}>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{
                    backgroundColor: '#F5F5F5',
                    color: '#000000',
                    fontWeight: 'bolder',
                    height: '100%',
                    marginRight: 'auto',
                    padding: '5px',
                    width: '100%',
                    [theme.breakpoints.up('md')]: { borderTop: '2px solid #858585' }
                }}
                >
                    Dirección
                </Typography>
            </Grid>
            <Grid item xs={6} 
                sx={{
                    borderBottom: '2px solid #858585',
                    height: '30px',
                    [theme.breakpoints.up('md')]: { borderTop: '2px solid #858585' }
                }}>
                <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.client_address_billing?.toUpperCase()}</Typography>
            </Grid>
            <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{
                    backgroundColor: '#F5F5F5',
                    color: '#000000',
                    fontWeight: 'bolder',
                    height: '100%',
                    marginRight: 'auto',
                    padding: '5px',
                    width: '100%'
                }}
                >
                    Comuna
                </Typography>
            </Grid>
            <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.district_customer_billing?.toUpperCase()}</Typography>
            </Grid>
            <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{
                    backgroundColor: '#F5F5F5',
                    color: '#000000',
                    fontWeight: 'bolder',
                    height: '100%',
                    marginRight: 'auto',
                    padding: '5px',
                    width: '100%'
                }}
                >
                    Ciudad
                </Typography>
            </Grid>
            <Grid item xs={6} sm={3} md={3} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px' }}>{ticket?.province_customer_billing?.toUpperCase()}</Typography>
            </Grid>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{
                    backgroundColor: '#F5F5F5',
                    color: '#000000',
                    fontWeight: 'bolder',
                    height: '100%',
                    marginRight: 'auto',
                    padding: '5px',
                    width: '100%'
                }}
                >
                    País
                </Typography>
            </Grid>
            <Grid item xs={6} sx={{ borderBottom: '2px solid #858585', height: '30px' }}>
                <Typography sx={{ color: '#000000', marginRight: 'auto', paddingLeft: '5px',lineHeight: '100%', }}>{ticket?.country_customer_billing?.toUpperCase()}</Typography>
            </Grid>
        </Grid>
    </>)
}
